import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import AdminAuthSlice from "./AdminAuthSlice";
import persistStore from "redux-persist/es/persistStore";
import storageSession from "redux-persist/lib/storage/session";

const persistConfig = {
  key: "root",
  storage: storageSession,
  version: -1,
};

const reducer = combineReducers({
  Auth: AdminAuthSlice,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = () => {
  const persistor = persistStore(store);
  return persistor;
};
